module.exports = __webpack_public_path__ + "static/media/bl.023ea624.svg";